import React from 'react';
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import { diffCheck } from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';

const AccountMetaAction = ({ show, action: { action, error, data }, onHide }) => {
    const { meta, fields } = data

    return <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
    >
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Text/Code.svg")}
                    />
                </span> {action}
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
        </Modal.Header>
        <Modal.Body>
            <ErrorMessage {...{ error }} />
            <div className="px-md-5">
                {
                    Object.keys(meta)?.map((key) => {
                        return (
                            <div key={key} className="row mb-4">
                                <div className="col-md h6">
                                    {key}
                                </div>
                                <div className="col-md h6 text-muted">
                                    {fields[key] === undefined ? meta[key].toString() : diffCheck(meta[key].toString(), fields[key].toString())}
                                </div>
                            </div>
                        )
                    })
                }
                {
                    Object.keys(fields)?.map((key) => meta[key] === undefined
                        ? (
                            <div key={key} className="row mb-4 text-primary">
                                <div className="col-md h6">
                                    {key}
                                </div>
                                <div className="col-md h6">
                                    {fields[key]}
                                </div>
                            </div>
                        )
                        : null
                    )
                }
            </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
    </Modal>
}

export default AccountMetaAction;